import { defineMessages } from "react-intl";

import { node as diabetology } from "src/modules/ktx/forms/transplantation-screening/consultations/diabetology";
import { node as endocrinology } from "src/modules/ktx/forms/transplantation-screening/consultations/endocrinology";
import { node as gastroenterology } from "src/modules/ktx/forms/transplantation-screening/consultations/gastroenterology";
import { node as genetics } from "src/modules/ktx/forms/transplantation-screening/consultations/genetics";
import { node as hematology } from "src/modules/ktx/forms/transplantation-screening/consultations/hematology";
import { node as hepatology } from "src/modules/ktx/forms/transplantation-screening/consultations/hepatology";
import { node as immunology } from "src/modules/ktx/forms/transplantation-screening/consultations/immunology";
import { node as neurology } from "src/modules/ktx/forms/transplantation-screening/consultations/neurology";
import { node as oncology } from "src/modules/ktx/forms/transplantation-screening/consultations/oncology";
import { node as psychiatry } from "src/modules/ktx/forms/transplantation-screening/consultations/psychiatry";
import { node as pulmonology } from "src/modules/ktx/forms/transplantation-screening/consultations/pulmonology";
import { node as transplantAnesthesiology } from "src/modules/ktx/forms/transplantation-screening/consultations/transplantAnesthesiology";
import { node as transplantNephrology } from "src/modules/ktx/forms/transplantation-screening/consultations/transplantNephrology";
import { node as transplantSurgery } from "src/modules/ktx/forms/transplantation-screening/consultations/transplantSurgery";
import { node as vascularSurgery } from "src/modules/ktx/forms/transplantation-screening/consultations/vascularSurgery";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.consultations",
		defaultMessage: "Konzíliumok"
	}
});

export const node: ParentNode = {
	id: "ktx-consultations",
	value: { type: "wizard", title: messages.title },
	children: [
		diabetology,
		endocrinology,
		vascularSurgery,
		gastroenterology,
		genetics,
		hematology,
		hepatology,
		oncology,
		psychiatry,
		pulmonology,
		transplantAnesthesiology,
		transplantNephrology,
		transplantSurgery,
		neurology,
		immunology
	]
};
